import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import * as styles from './CompanyField.scss';
import Tooltip from '../CompanyTooltip/CompanyTooltip';

export default class InputField extends Component {
  state = {
    showTooltip: false
  };

  handleMouseEnter = () => {
    const { meta: { touched, error } } = this.props;

    if (error && touched) {
      this.setState({ showTooltip: true });
    }
  };

  handleMouseLeave = () => {
    if (this.state.showTooltip) {
      this.setState({ showTooltip: false });
    }
  };

  input = null;

  render() {
    const { input, type, placeholder, meta, isRtl, field_id, isTextarea, maxLength, disabledMaxLength } = this.props;
    const id = field_id || `company-contact-us-${input.name}`;
    const InputTeg = isTextarea ? 'textarea' : 'input';

    return (
      <label
        htmlFor={`company-contact-us-${input.name}`}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <InputTeg
          id={id}
          {...input}
          type={type}
          placeholder={placeholder}
          className={cx({ 'has-error': meta.error && !meta.active && meta.touched, touched: meta.touched })}
          ref={(ref) => { this.input = ref; }}
          onClick={evt => evt.stopPropagation()}
          maxLength={maxLength}
        />
        {!disabledMaxLength && maxLength &&
          <div className={styles.maxLength}>
            <p>
              {input.value.length} / {maxLength}
            </p>
          </div>
        }

        { this.state.showTooltip && !meta.active && (
          <Tooltip tooltipFor={this.input} isRtl={isRtl}>
            <span>{ this.props.translateForError(meta.error) }</span>
          </Tooltip>
        ) }
      </label>
    );
  }
}

InputField.propTypes = {
  translateForError: PropTypes.func,
  input: PropTypes.object,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  meta: PropTypes.object,
  isRtl: PropTypes.bool,
  field_id: PropTypes.string,
  isTextarea: PropTypes.bool,
  disabledMaxLength: PropTypes.bool,
  maxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
